app.factory("DocumentsService", ["$http",
    function ($http) {
        var DocumentsService = {};

        DocumentsService.send = function (params) {
            return $http.post("/documents/send", params).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.studentSent = function (params) {
            return $http.post("/documents/send/student", params).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.registerStudentsDoc = function (params) {
            return $http.post("/documents/register/studentDocument", params).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.resolve = function (params) {
            return $http.post("/documents/resolve", params).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.resolveStudentsDoc = function (params) {
            return $http.post("/documents/student/resolve", params).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.fetchOne = function (documentId) {
            return $http.get("/documents/" + documentId).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.reviewList = function (params) {
            return $http.get("/documents/review", params).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.reviewedList = function (params) {
            return $http.get("/documents/reviewed", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    type: params.type,
                    chancelleryStatus: params.chancelleryStatus,
                    isDone: params.documentState,
                    uniqueNumber: params.uniqueNumber,
                    fromDate: params.fromDate,
                    toDate: params.toDate,
                    author: params.author,
                    addressee: params.addressee,
                    chancelleryWorker: params.chancelleryWorker
                }
            }).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.incomingList = function (params) {
            return $http.get("/documents/inbox", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    type: params.type,
                    parentType: params.parentType,
                    status: params.state,
                    uniqueNumber: params.uniqueNumber,
                    actionRequired: params.actionRequired,
                    fromDate: params.fromDate,
                    toDate: params.toDate,
                    authorEmp: params.authorEmp,
                    authorSt: params.authorSt,
                    authorOrg: params.authorOrg
                }
            }).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.documentsFromStudents = function (params) {
            return $http.get("/documents/forStudent", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    type: params.type,
                    parentType: params.parentType,
                    state: params.state,
                    subState: params.subState,
                    uniqueNumber: params.uniqueNumber,
                    fromDate: params.fromDate,
                    toDate: params.toDate,
                    author: params.author
                }
            }).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.sentList = function (params) {
            return $http.get("/documents/sent", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    type: params.type,
                    status: params.state,
                    uniqueNumber: params.uniqueNumber,
                    fromDate: params.fromDate,
                    toDate: params.toDate,
                    addressee: params.addressee,
                    addresseeOrganizationalUnit: params.addresseeOrganizationalUnit,
                    onlyOrganizationDrafts: params.onlyOrganizationDrafts
                }
            }).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.studentSentList = function (params) {
            return $http.get("/documents/student/sent", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    type: params.type,
                    status: params.state,
                    uniqueNumber: params.uniqueNumber,
                    fromDate: params.fromDate,
                    toDate: params.toDate,
                    addressee: params.addressee
                }
            }).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.studentReceivedList = function (params) {
            return $http.get("/documents/student/received", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    type: params.type,
                    status: params.state,
                    uniqueNumber: params.uniqueNumber,
                    fromDate: params.fromDate,
                    toDate: params.toDate,
                    addressee: params.addressee
                }
            }).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.getCounts = function (params) {
            return $http.get("/documents/counts", params).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.markWithStatus = function (params) {
            return $http.post("/documents/markWithStatus", params).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.setChancelleryStatus = function (params) {
            return $http.post("/documents/" + params.documentId + "/review", params).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.setAddresseeStatus = function (params) {
            return $http.post("/documents/" + params.documentId + "/answer", params).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.setAddresseeStatusToStudentsDoc = function (params) {
            return $http.post("/documents/" + params.documentId + "/student/answer", params).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.removeAttachment = function (fileId) {
            return $http.delete("/documents/attachments/" + fileId).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.removeDraft = function (docId) {
            return $http.delete("/documents/drafts/" + docId).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.staffList = function (params) {
            return $http.get("/sudo/documents/staff/list", { params: params }).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.staffAdd = function (params) {
            return $http.post("/sudo/documents/staff/add", params).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.staffRemove = function (params) {
            return $http.delete("/sudo/documents/staff/" + params._id).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.staffAddToOrg = function (params) {
            return $http.post("/sudo/documents/staff/organization/add", params).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.staffEditToOrg = function (params) {
            return $http.put("/sudo/documents/staff/" + params.employee + '/organization/info', params).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.staffRemoveFromOrg = function (employeeId) {
            return $http.delete("/sudo/documents/staff/" + employeeId + "/organization").then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.positionsList = function (params) {
            return $http.get("/positions/list", { params: params }).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.typeList = function (params) {
            var url = '/documents/type/list/';
            if (params.admin) url += '?admin=true';
            else url += '?admin=false';
            if (params.type) url += "&parentId=" + params.type;
            if (params.userId) url += "&userId=" + params.userId;
            return $http.get(url).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.studentDocTypes = function () {
            return $http.get('/documents/type/list/?student=true').then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.addDocType = function (params) {
            return $http.post("/documents/type", params).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.editDocType = function (params) {
            return $http.put("/documents/type", params).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.removeDocType = function (typeId) {
            return $http.delete('/documents/type/' + typeId).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.getDocumentAddressee = function (params) {
            var url = '/documents/addressee/by/position';
            if (params.userId) url += "?userId=" + params.userId + '&';
            else url += '?'
            if (params.isResolution) url += "isResolution=" + params.isResolution;
            return $http.get(url).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.generateDocTypes = function () {
            return $http.post("/documents/type/generate", {}).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.getVacationTypeDocs = function () {
            return $http.post("/documents/vacation", {}).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.fetchEmployee = function (employeeId) {
            return $http.get("/sudo/documents/staff/" + employeeId, {}).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.getEmployee = function (employeeId) {
            return $http.get("/documents/staff/" + employeeId, {}).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.deleteDocument = function (documentId) {
            return $http.delete("/documents/" + documentId, {}).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.finalizeDocuments = function (formData) {
            return $http.post("/documents/finalize", formData, {
                headers: { 'Content-Type': undefined }
            }).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.getDocumentNumbers = function (reqData) {
            return $http.post("/documents/byUniqueNumber", reqData).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.shareDocument = function (reqData) {
            return $http.post("/documents/share", reqData).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.getSharedDocuments = function (reqData) {
            return $http.post("/documents/shared", reqData).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.markSharedDocument = function (reqData) {
            return $http.post("/documents/shared/read", reqData).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.externalDocumentsList = function (params) {
            return $http.get("/documents/list/baseType", { params: params }).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.sendersList = function (params) {
            return $http.get("/documents/senders/list", { params: params }).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.register = function (params) {
            return $http.post("/documents/register", params).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.getDocumentAddresseeExternal = function () {
            return $http.get("/documents/addressee/external").then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.addComment = function (documentId, comment) {
            return $http.post(`documents/${documentId}/comment`, comment).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.getDocumentByUniqueNumber = function (reqData) {
            return $http.post("/documents/byUniqueNumber", reqData).then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.getTemplateList = function () {
            return $http.get("/documents/outgoing/template/list").then(function (resp) {
                return resp.data;
            });
        };

        DocumentsService.generateTemplate = function (params) {
            return $http.post("/documents/outgoing/template/generate", params);
        };

        DocumentsService.registerOutgoing = function (params) {
            let url = "/documents/outgoing/register";
            if (params.student) {
                url = "/documents/outgoing-student/register"
            }
            return $http.post(url, params).then(function (resp) {
                return resp;
            });
        };

        DocumentsService.getActions = function (documentId) {
            return $http.get(`/documents/${documentId}/actions`).then(function (resp) {
                return resp;
            });
        }

        DocumentsService.review = function (params) {
            return $http.post('/documents/outgoing/review/document', params).then(function (resp) {
                return resp;
            });
        }

        return DocumentsService;
    }
]);
